// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"316":"f0a89eaaf061860d","809":"4fafa587bf21541d"}[chunkId] + ".js";
};